export enum StakingScreenEnum {
  HOME_SCREEN = 'HOME_SCREEN',
  STAKE_SCREEN = 'STAKE_SCREEN',
  STAKE_SUCCESS = 'SUCCESSFUL_STAKE',
  UNSTAKE_SCREEN = 'UNSTAKE_SCREEN',
  UNSTAKE_SUCCESS = 'UNSTAKE_SUCCESS',
  UNSTAKE_IMMEDIATELY_SUCCESS = 'UNSTAKE_IMMEDIATELY_SUCCESS',
  WITHDRAW_CONFIRM = 'WITHDRAW_CONFIRM',
  WITHDRAW_SUCCESS = 'WITHDRAW_SUCCESS',
  ERROR = 'ERROR',
  TRANSACTION_HISTORY = 'TRANSACTION_HISTORY',
}
